import React from 'react'
import { motion } from 'framer-motion'
import {
  SiReact, SiNodedotjs, SiExpress, SiPython,
  SiMongodb, SiMysql, SiFirebase, SiGooglecloud,
  SiStripe, SiDocker
} from 'react-icons/si'
import { FiCpu, FiDatabase, FiCloud, FiLayout } from 'react-icons/fi'

const skillGroups = [
  {
    title: 'Frontend',
    icon: <FiLayout />,
    skills: [
      { name: 'React.js', icon: <SiReact /> },
      { name: 'React Native', icon: <SiReact /> },
      { name: 'JavaScript', icon: null },
    ]
  },
  {
    title: 'Backend & AI',
    icon: <FiCpu />,
    skills: [
      { name: 'Node.js', icon: <SiNodedotjs /> },
      { name: 'Express', icon: <SiExpress /> },
      { name: 'Python', icon: <SiPython /> },
      { name: 'LangChain', icon: null },
    ]
  },
  {
    title: 'Cloud & DevOps',
    icon: <FiCloud />,
    skills: [
      { name: 'Cloud Run', icon: <SiGooglecloud /> },
      { name: 'Cloud Functions', icon: <SiGooglecloud /> },
      { name: 'Apps Script', icon: null },
      { name: 'Docker', icon: <SiDocker /> },
    ]
  },
  {
    title: 'Databases & APIs',
    icon: <FiDatabase />,
    skills: [
      { name: 'MongoDB', icon: <SiMongodb /> },
      { name: 'MySQL', icon: <SiMysql /> },
      { name: 'Firebase', icon: <SiFirebase /> },
      { name: 'Stripe', icon: <SiStripe /> },
    ]
  }
]

const Services = () => {
  return (
    <div id='services'>
      <p className="section-label">Tech Stack</p>
      <h2 className="section-title">Skills & Expertise</h2>

      <div className="skillsGrid">
        {skillGroups.map((group, i) => (
          <motion.div
            className="skillGroup"
            key={group.title}
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
          >
            <div className="skillGroupHeader">
              <span className="skillGroupIcon">{group.icon}</span>
              <h3>{group.title}</h3>
            </div>
            <div className="skillPills">
              {group.skills.map(skill => (
                <div className="skillPill" key={skill.name}>
                  {skill.icon && <span className="skillPillIcon">{skill.icon}</span>}
                  {skill.name}
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default Services